module.exports = __webpack_public_path__ + "static/media/S_simul3.795a13f9.png";